// extracted by mini-css-extract-plugin
export default {"main":"SearchBar_main__b8V3h","search_bar":"SearchBar_search_bar__Z3xcx"};